import { Card } from "@cvpartner/design-system";
import type * as React from "react";
import {
  card,
  cardContent,
  cardHeading,
  cardSubheading,
  cardSubheadingMultiple,
  headingWrapper,
} from "./LoginCard.css.ts";

const Subheading: React.FC<{
  subheading: string | readonly string[] | undefined;
}> = ({ subheading }) => {
  if (!subheading) {
    return null;
  }

  if (typeof subheading === "string") {
    return <h3 className={cardSubheading}>{subheading}</h3>;
  }

  return (
    <>
      {subheading.map((paragraph, index) => (
        <p key={index} className={cardSubheadingMultiple}>
          {paragraph}
        </p>
      ))}
    </>
  );
};

export const LoginCard: React.FC<{
  heading: string;
  subheading?: string | readonly string[];
  children: React.ReactNode;
}> = ({ heading, subheading, children }) => {
  return (
    <Card
      backgroundColor="inkLight50"
      borderRadius={4}
      boxShadow="m"
      padding={8}
    >
      <div className={card}>
        <div className={headingWrapper}>
          <h2 className={cardHeading}>{heading}</h2>
          <Subheading subheading={subheading} />
        </div>
        {children}
      </div>
    </Card>
  );
};

export const CardContent: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => <div className={cardContent}>{children}</div>;
